import {Box, ClickAwayListener, InputLabel, Popper} from "@mui/material";
import Button from "@mui/material/Button";
import React, {memo, useState} from "react";
import {useTheme} from "@mui/material/styles";
import { HexColorPicker } from "react-colorful";

const MhdSolidColorWidget = ({ label, value, errMsg, onChange, disabled }) => {
  const theme = useTheme()
  const [anchor, setAnchor] = useState(null);

  return (
    <Box>
      <Popper
        open={Boolean(anchor)}
        anchorEl={anchor}
        placement="bottom-start" // Adjust as needed
        modifiers={[
          {
            name: 'flip',
            enabled: true,
          },
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              boundary: 'viewport',
            },
          },
        ]}
        style={{ zIndex: 50 }} // Ensure it appears above other elements
      >
        <ClickAwayListener onClickAway={() => setAnchor(null)}>
          <Box
            sx={{
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
              '.react-colorful': {
                height: '240px',
                width: '240px',
              },
              '.react-colorful__saturation': {
                borderRadius: '4px 4px 0 0',
              },
              '.react-colorful__saturation-pointer': {
                width: '10px',
                height: '10px',
                borderRadius: 2,
                border: '1px solid #FFFFFF'
              },
              '.react-colorful__hue': {
                height: '20px',
                borderRadius: '0 0 4px 4px',
              },
              '.react-colorful__hue-pointer': {
                width: '10px',
                height: '20px',
                borderRadius: 0,
                border: '2px solid #FFFFFF'
              },
            }}
          >
            <HexColorPicker
              onChange={(e) => onChange(e)}
              color={value}
            />
          </Box>
        </ClickAwayListener>
      </Popper>

      <InputLabel variant='primary'>
        {label}
      </InputLabel>

      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        variant={'contained'}
        sx={{
          minWidth: '0',
          height: '28px',
          borderRadius: '4px',
          bgcolor: `${value}`,
          '&:hover': {
            bgcolor: `${value}`,
            opacity: .7
          }
      }}
      />
    </Box>
  );
};

export default memo(MhdSolidColorWidget);